import "/css/site.css";
import { initializeGlobal } from "./global.js";
import TurboDrive from "./global-controllers/turbo/TurboDrive.js";
const events = initializeGlobal([TurboDrive]);
events.onGlobal("turbodrive:load", () => {
    const browser = window;
    if (browser.wagtail) {
        browser.wagtail.userbar = document.querySelector("wagtail-userbar");
    }
});
//# sourceMappingURL=site.js.map